import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ClientProfile, Environment, Response } from '@viso/core/models';
import { ENVIRONMENT } from '../environment/environment.service';

@Injectable({
  providedIn: 'root',
})
export class ClientProfileService {
  constructor(
    private http: HttpClient,
    @Inject(ENVIRONMENT) private environment: Environment
  ) {}

  updateProfile(client: ClientProfile) {
    return this.http.put<Response<ClientProfile>>(
      `${this.environment.API_URL}/client/profile`,
      client
    );
  }

  getClientProfile() {
    return this.http.get<Response<ClientProfile>>(
      `${this.environment.API_URL}/client/profile`
    );
  }
}
